export default {
  'extraUserFields.title': 'Manage Extra User Fields',

  'extraUserFields.isAllowMultipleChoicesEnabled': 'Allow Multiple Choices?',
  'extraUserFields.isAutoSelectItemEnabled': 'Auto Select Item?',
  'extraUserFields.isAllowInsertOptionManuallyEnabled': 'Allow Insert Option Manually?',
  'extraUserFields.choices': 'Options',
  'extraUserFields.dynamicTableFieldOrderDirection': 'Ordering Type',
  'extraUserFields.groupingType': 'Grouping Type',
  'extraUserFields.dynamicEntity': 'Dynamic Entity',
  'extraUserFields.dynamicEntityField': 'Dynamic Entity Field',
  'extraUserFields.isManagementVisible': 'Visible in Users Listing?',
};
